import { render, staticRenderFns } from "./Activity12.vue?vue&type=template&id=6d1c975b&scoped=true"
import script from "./Activity12.vue?vue&type=script&lang=js"
export * from "./Activity12.vue?vue&type=script&lang=js"
import style0 from "./Activity12.vue?vue&type=style&index=0&id=6d1c975b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c975b",
  null
  
)

export default component.exports